export default __webpack_public_path__ + "static/media/app_logo.ed84ecce.png";